import { apiClient } from '@/shared/api';
import type {
  TermCreate,
  TermCreateResponse,
  TermListParams,
  TermListResponse,
  TermResponse,
  TermUpdate,
} from './types';

// Re-export types for convenience
export type { TermCreate, TermCreateResponse, TermListParams, TermListResponse, TermResponse, TermUpdate };

/**
 * Fetch a list of terms per OpenAPI GET /term
 */
export const fetchTerms = async (params?: TermListParams): Promise<TermListResponse> => {
  const { data } = await apiClient.get<TermListResponse>('/term', { params });
  return data;
};

/**
 * Fetch a term by ID per OpenAPI GET /term/{id}
 */
export const fetchTerm = async (id: number | string): Promise<TermResponse> => {
  const { data } = await apiClient.get<TermResponse>(`/term/${id}`);
  return data;
};

/**
 * Create a term per OpenAPI POST /term
 */
export const createTerm = async (payload: TermCreate): Promise<TermCreateResponse> => {
  const { data } = await apiClient.post<TermCreateResponse>('/term', payload);
  return data;
};

/**
 * Update a term per OpenAPI PUT /term/{id}
 */
export const updateTerm = async (id: number | string, payload: TermUpdate): Promise<TermResponse> => {
  const { data } = await apiClient.put<TermResponse>(`/term/${id}`, payload);
  return data;
};

/**
 * Delete a term per OpenAPI DELETE /term/{id}
 */
export const deleteTerm = async (id: number | string): Promise<void> => {
  await apiClient.delete(`/term/${id}`);
};
